import axios from 'axios';
import toast from 'react-hot-toast';
import { useKotContext } from '../context/kotContext';
import { useEffect, useState } from 'react';
import { buildKotPrintDocument, printKotDocuments, splitKotItems } from './kotPrintUtils';

const UpdateKotPrint = (arr1, tableNo, totalAmount, selectedServerName) => {
  const { kotNumber } = useKotContext(); // Removed serverName from context
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');

  const customerId = localStorage.getItem('customerId');

  function getFormattedCurrentDate() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    let hours = now.getHours();
    let minutes = String(now.getMinutes()).padStart(2, '0');
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return [`${day}-${month}-${year}`, `${hours}:${minutes}${period.toLowerCase()}`];
  }

  useEffect(() => {
    const [formattedDate, formattedTime] = getFormattedCurrentDate();
    setDate(formattedDate);
    setTime(formattedTime);
  }, [customerId, tableNo]);

  const printKot = async () => {
    try {
      const response = await axios.patch('https://api.rcb.tdrsoftware.in/api/kotBillUpdate', {
        customerId: customerId,
        kotNo: kotNumber,
        data: {
          foodItem: arr1,
        },
        serverName: selectedServerName, // Use prop
      });

      toast.success(response.data.message);

      const data = response.data.updatedFoodItems || [];
      // The legacy update response contains deltas but no category. Resolve its
      // exact item names against the current full KOT, leaving delta values and
      // notes untouched. The shared helper also handles known portion suffixes.
      const { foodItems, barItems } = splitKotItems(data, arr1);
      const documents = [
        ['Food KOT', foodItems],
        ['Beer / Bar KOT', barItems],
      ].filter(([, items]) => items.length > 0).map(([title, items]) => buildKotPrintDocument({
        title, items, tableNo, kotNo: kotNumber, serverName: selectedServerName,
        date, time, quantityMode: 'delta',
      }));
      await printKotDocuments(documents);

    } catch (error) {
      console.error('Error saving bill:', error);
      toast.error('Error in Kot');
    }
  };

  return printKot;
};

export default UpdateKotPrint;
